var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoniczka14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 635.83 813.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:20px;}.cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "doniczka1-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_6",
    "data-name": "Warstwa 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1162.73,584.78l-68.57-.76c6.79-10.71,13.85-21.39,21.13-31.95,74.76-108.42,196.93-193.64,183.71-164.93-48,104.33-22.64,121.39-67.32,197.79Z",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M821.43,584.78,890,584c-6.78-10.71-13.84-21.39-21.12-31.95C794.11,443.65,671.93,358.43,685.15,387.14c48.05,104.33,22.65,121.39,67.33,197.79Z",
    transform: "translate(-674.16 -158.52)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_4",
    "data-name": "Warstwa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M940.65,585c-32.08-38.82-54.18-108-44.71-186.63,13.28-110.23,97.69-272.26,101.84-219.63,6,76.68,97.28,116.23,101.83,219.63,3.47,78.76-16.8,147.86-46.85,186.63",
    transform: "translate(-674.16 -158.52)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_7",
    "data-name": "Warstwa 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M788.19,457.76",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M790.19,457.76q-.11-5.38.28-11c6.8-101.07-17.59-179.16-16.16-184.77,7.86-30.93,81,41.89,121.43,126.51",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1205.87,446.78",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1080,584",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1211.87,438.78C1205.06,337.71,1229.45,259.62,1228,254c-8.17-32.11-86.67,47.57-125.9,136.21-.66,1.5-1.32,3-2,4.51",
    transform: "translate(-674.16 -158.52)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_9",
    "data-name": "Warstwa 9"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.84,
    y1: 482.48,
    x2: 595.84,
    y2: 482.48
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_8",
    "data-name": "Warstwa 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1216,962H768c-50,0-58-377-58-377h562S1268,962,1216,962Z",
    transform: "translate(-674.16 -158.52)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_10",
    "data-name": "Warstwa 10"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 322.84,
    y1: 482.48,
    x2: 322.84,
    y2: 804.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M997,641",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 322.84,
    y1: 426.48,
    x2: 322.84,
    y2: 427.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M771,638.45c3.18,97.12,12.17,295,33.12,323.55",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M770.92,637.42c0,.34,0,.69,0,1",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M770.92,637.42",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M769.51,586.36c0,.53,0,1.2,0,2",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M769.48,584.93s0,.49,0,1.43",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1212.52,641c-3.26,98-12.28,292.74-33,321",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1212.52,641",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1214.08,584.93s0,.49,0,1.43",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M832.33,638.45c.48,102.38,3.14,316.71,16.76,323.55",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M832.33,638.45",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M832.23,585s0,2.36,0,6.71",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1155,641c-.52,103.34-3.24,314.21-16.75,321",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1155,641",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1155.07,585s0,.46,0,1.35",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 221.84,
    y1: 483.76,
    x2: 221.84,
    y2: 802.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M896,642.28",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 221.84,
    y1: 425.48,
    x2: 221.84,
    y2: 428.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 425.84,
    y1: 482.48,
    x2: 425.84,
    y2: 802.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1100,641",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 425.84,
    y1: 425.48,
    x2: 425.84,
    y2: 427.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 276.84,
    y1: 482.48,
    x2: 276.84,
    y2: 802.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M951,641",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 276.84,
    y1: 425.48,
    x2: 276.84,
    y2: 427.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 371.84,
    y1: 482.48,
    x2: 371.84,
    y2: 802.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1046,641",
    transform: "translate(-674.16 -158.52)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 371.84,
    y1: 425.48,
    x2: 371.84,
    y2: 427.84
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoniczka14);
export default __webpack_public_path__ + "static/media/doniczka1-4.49097d335e54f3ecbc5007926f20eaed.svg";
export { ForwardRef as ReactComponent };